import { DecorationsListContainer } from '../../containers/advancedFilters/DecorationsListContainer';
import { IFilter } from '../../types/advancedFilters';

export const decorationsList: IFilter = {
  component: DecorationsListContainer,
};
